import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScheduleExport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.575 13.844a.75.75 0 0 0-1.061 0l-.846.845v-3.327a.75.75 0 1 0-1.5 0v3.327l-.846-.845a.75.75 0 1 0-1.06 1.06l2.656 2.657 2.657-2.657a.75.75 0 0 0 0-1.06m-5.942-6.843a.75.75 0 0 0-.75.75v2H8.807a.75.75 0 0 0 0 1.5h1.626a.95.95 0 0 0 .95-.95v-2.55a.75.75 0 0 0-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.03 4.25a5.75 5.75 0 0 0-1.359 11.339.75.75 0 0 1-.353 1.458 7.25 7.25 0 1 1 8.895-8.038.75.75 0 1 1-1.486.203A5.75 5.75 0 0 0 10.03 4.25"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScheduleExport;
